
import bb from "blingblingjs";


bb('.step__footer__previous-link').on('click', e => {
    e.preventDefault();
    window.history.back();
})
